import { render, staticRenderFns } from "./AcademicPlantResearchers.html?vue&type=template&id=fe37e5d8&scoped=true&"
import script from "./AcademicPlantResearchers.vue?vue&type=script&lang=js&"
export * from "./AcademicPlantResearchers.vue?vue&type=script&lang=js&"
import style0 from "./AcademicPlantResearchers.scss?vue&type=style&index=0&id=fe37e5d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe37e5d8",
  null
  
)

export default component.exports